import React from 'react';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen pt-20">
      <section className="relative h-80 flex items-center justify-center overflow-hidden bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900">
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Service</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            TOTAL VISION Oil and Gas Fields Services and Consultancy LLC SPC
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <p className="text-lg text-slate-700 leading-relaxed mb-8">
              These Terms of Service ("Terms") govern your access to and use of the services, website, platforms, and business interactions provided by TOTAL VISION Oil and Gas Fields Services and Consultancy LLC SPC ("TOTAL VISION", "we", "our", or "us"). By engaging with our company or using our services, you acknowledge and agree to these Terms.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-700 leading-relaxed mb-6">
              By accessing our website, requesting services, or entering into a contract with TOTAL VISION, you agree to comply with these Terms and all applicable laws and regulations. If you do not agree, you must discontinue use of our services.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">2. Scope of Services</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              TOTAL VISION provides engineering, consultancy, construction, supply chain, mentoring, and oil & gas field services.
            </p>
            <p className="text-slate-700 leading-relaxed mb-3">
              All services are delivered based on:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Signed contracts</li>
              <li>Approved proposals</li>
              <li>Project specific documentation</li>
              <li>Applicable industry standards and regulations</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              We reserve the right to modify or update service offerings as required.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">3. Use of Our Website and Digital Platforms</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              Users agree to:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Access our website and platforms responsibly</li>
              <li>Not engage in unauthorized access, data extraction, or misuse</li>
              <li>Not upload harmful, illegal, or malicious content</li>
              <li>Accept that website content may be updated without notice</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              TOTAL VISION is not responsible for temporary unavailability due to maintenance or technical issues.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">4. Client Obligations</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              Clients engaging TOTAL VISION agree to:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Provide accurate, complete, and timely information</li>
              <li>Ensure access to project sites, documentation, and personnel as required</li>
              <li>Comply with all legal, regulatory, and safety requirements</li>
              <li>Make payments according to agreed terms</li>
              <li>Communicate changes in scope or requirements promptly</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              TOTAL VISION is not liable for delays or issues caused by incomplete or inaccurate client inputs.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">5. Fees, Payments, and Invoicing</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              All fees are defined in formal quotations or contracts. Clients agree to:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Pay invoices within the agreed payment period</li>
              <li>Cover additional costs arising from scope changes or unforeseen conditions</li>
              <li>Accept that late payments may result in service suspension or additional charges</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">6. Confidentiality</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              Both parties agree to maintain strict confidentiality regarding:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Technical data</li>
              <li>Commercial information</li>
              <li>Project documentation</li>
              <li>Proprietary methodologies</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              Information may only be disclosed when required by law or with written consent.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">7. Intellectual Property Rights</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              Unless otherwise stated in writing:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>All engineering deliverables, designs, methodologies, and documents created by TOTAL VISION remain our intellectual property</li>
              <li>Clients receive usage rights solely for the specific project or purpose defined in the contract</li>
              <li>Reproduction, distribution, or modification without written approval is prohibited</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">8. Third Party Services and Vendors</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              TOTAL VISION may engage third party vendors, subcontractors, or service providers.
            </p>
            <p className="text-slate-700 leading-relaxed mb-3">
              We ensure they meet required standards, but we are not responsible for:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Their independent actions</li>
              <li>Delays caused by external suppliers</li>
              <li>Failures outside our direct control</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">9. Limitation of Liability</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              TOTAL VISION is not liable for:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Indirect, incidental, or consequential damages</li>
              <li>Losses arising from misuse of information</li>
              <li>Delays caused by regulatory, environmental, or supply chain factors</li>
              <li>Issues resulting from client driven changes or incomplete data</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              Our liability is limited to the value of the specific contract under which a claim arises.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">10. Warranties and Service Quality</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              TOTAL VISION provides services with professional skill, diligence, and adherence to industry standards.
            </p>
            <p className="text-slate-700 leading-relaxed mb-3">
              However, we do not guarantee:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Outcomes beyond our control</li>
              <li>Performance of third party vendors</li>
              <li>Results affected by client initiated changes</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">11. Termination of Services</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              Either party may terminate a contract with written notice if:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>The other party breaches contractual obligations</li>
              <li>Payment terms are not met</li>
              <li>Safety, regulatory, or ethical concerns arise</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              Upon termination, clients must settle all outstanding invoices and costs incurred.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">12. Compliance and Legal Requirements</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              TOTAL VISION complies with:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Local and regional regulations</li>
              <li>Industry best practices</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              Clients must ensure their own compliance with applicable laws.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">13. Governing Law</h2>
            <p className="text-slate-700 leading-relaxed mb-6">
              These Terms are governed by the laws and regulations of the United Arab Emirates, unless otherwise specified in a formal agreement.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">14. Amendments</h2>
            <p className="text-slate-700 leading-relaxed mb-6">
              TOTAL VISION may update or modify these Terms at any time. Updated versions will be published on our official platforms.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">15. Contact Information</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              For questions or concerns regarding these Terms of Service, please contact:
            </p>
            <p className="text-slate-900 font-semibold mb-2">
              TOTAL VISION Oil and Gas Fields Services and Consultancy LLC SPC
            </p>
            <p className="text-slate-700 leading-relaxed">
              Official communication channels will be provided upon request.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfServicePage;